import styled, { css } from 'styled-components'
import { device, fonts } from '../../../styles/GlobalVariables'

interface StyledLayoutWrapper {
  isHp: boolean
}

export const ViewLayoutWrapper = styled.div<StyledLayoutWrapper>`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  ${props => (!props.isHp ? css`` : '')}
  * {
    box-sizing: border-box;
    font-family: ${fonts.narkis};
  }

  > div[class^='OttTaboolastyle__OttTaboolaWrap'] {
    padding-bottom: 16vw;

    ${device.small} {
      padding-bottom: 0;
    }
  }
`
